import React, { useEffect } from "react";
import SectionHeader from "../components/SectionHeader";

export default function LegalPage({ kind }) {
  useEffect(() => {
    document.title = `${kind === "terms" ? "Terms & Conditions" : "Privacy Policy"} — Je Ke Pictures`;
  }, [kind]);

  const terms = (
    <div className="space-y-6 text-[color:var(--jk-muted)] leading-relaxed">
      <p>These Terms & Conditions govern your use of the Je Ke Pictures website. By accessing this site, you agree to abide by these terms.</p>
      <h3 className="font-cinzel text-white text-xl">Intellectual Property</h3>
      <p>All content — including film titles, images, trailers, music, artwork, and text — is the property of Je Ke Pictures Pvt. Ltd. or its licensors and is protected under Indian and international copyright law. No content may be reproduced without prior written consent.</p>
      <h3 className="font-cinzel text-white text-xl">Third-Party Media</h3>
      <p>Music videos and trailers embedded from YouTube are subject to YouTube's Terms of Service.</p>
      <h3 className="font-cinzel text-white text-xl">Contact Enquiries</h3>
      <p>Enquiries submitted via the contact form are handled in good faith. We do not guarantee a response to every message.</p>
      <h3 className="font-cinzel text-white text-xl">Changes</h3>
      <p>These terms may be updated from time to time without notice. Continued use of the site constitutes acceptance of the revised terms.</p>
    </div>
  );

  const privacy = (
    <div className="space-y-6 text-[color:var(--jk-muted)] leading-relaxed">
      <p>Je Ke Pictures Pvt. Ltd. respects your privacy. This policy describes what information we collect and how we use it.</p>
      <h3 className="font-cinzel text-white text-xl">Information We Collect</h3>
      <p>When you submit our contact form, we collect your name, email address, subject, and message. We may also log basic technical information (IP address, timestamp) for security and abuse prevention.</p>
      <h3 className="font-cinzel text-white text-xl">How We Use It</h3>
      <p>Contact-form submissions are used solely to respond to your enquiry. We do not sell, rent, or share your data with third parties for marketing purposes.</p>
      <h3 className="font-cinzel text-white text-xl">Cookies</h3>
      <p>The site uses only essential cookies required for admin authentication and session management. No third-party tracking cookies are set.</p>
      <h3 className="font-cinzel text-white text-xl">Contact</h3>
      <p>For any privacy-related concerns, write to us at jekepictures@gmail.com.</p>
    </div>
  );

  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-10 py-24 md:py-32" data-testid={`legal-page-${kind}`}>
      <SectionHeader
        eyebrow={kind === "terms" ? "Legal" : "Legal"}
        title={kind === "terms" ? "Terms & Conditions" : "Privacy Policy"}
      />
      {kind === "terms" ? terms : privacy}
    </div>
  );
}
